<script setup>
import LoadingBlock from "@/components/global-themed/LoadingBlock.vue";
import useActionCategories from '@/composables/useActionCategories';
import HiddenByCategoryGroupPanel from "@/components/actions/partials/HiddenByCategoryGroupPanel.vue";
import MoveGroupTransition from "@/components/transitions/MoveGroupTransition.vue";
import ZeroContent from "@/components/global-themed/ZeroContent.vue";
import {computed} from "vue";

const { data: categoriesData, isLoading } = useActionCategories(true);

const filteredCategoriesData = computed(() => {
  if (!categoriesData.value) {
    return;
  }

  return Object.values(categoriesData.value).filter(data => data.actions_count > 0);
});
</script>

<template>
  <LoadingBlock v-if="isLoading" />

  <ZeroContent v-else-if="!filteredCategoriesData?.length">
    Looks like there are no hidden actions to display.
  </ZeroContent>

  <MoveGroupTransition
    v-else
    class="tw-space-y-10"
  >
    <HiddenByCategoryGroupPanel
      v-for="data in filteredCategoriesData"
      :key="data.category"
      :category="data.category"
      :sub-categories="data.sub_categories"
    />
  </MoveGroupTransition>
</template>
